import { isFunction } from './is-function.guard';

/**
 * Checks if a value is an instance of a specific class or constructor function.
 * @param value The value to check.
 * @param constructor The constructor function to check against.
 * @returns True if value is an instance of constructor, false otherwise.
 *
 * @example
 * ```typescript
 * class MyClass {}
 * const instance = new MyClass();
 * console.log(isInstanceOf(instance, MyClass)); // true
 * ```
 * @example
 * ```typescript
 * class MyClass {}
 * const notInstance = {};
 * console.log(isInstanceOf(notInstance, MyClass)); // false
 * ```
 * @example
 * ```ts
 * isInstanceOf(new Date(), Date); // true
 * ```
 * @example
 * ```ts
 * isInstanceOf("hello", String); // false
 * ```
 */
// biome-ignore lint/suspicious/noShadowRestrictedNames: needed in order to match the type signature
// biome-ignore lint/suspicious/noExplicitAny: this is a generic utility function
export function isInstanceOf<T>(value: unknown, constructor: new (...args: any[]) => T): value is T {
  if (!isFunction(constructor)) {
    return false;
  }

  return value instanceof constructor;
}
